import React from "react";
import katherineImage from "../../../assets/Blackwomen/Copy-of-Website-Launch-Graphics-1-2.jpg"; // Replace with actual images
import katieImage from "../../../assets/Blackwomen/mobeaulity-hero1.png";
import Footer from "../../../components/Footer";
import HeroBg from "../../../assets/Blackwomen/BWI10.jpg";
import NavLite from "../../../components/NavLite";
import { Helmet } from "react-helmet";

const projects = [
  {
    title: "Money On Mind",
    description:
      "Custom Wix website for Mind Over Money helps Black women take charge of their finances and create realistic plans for early retirement. ",
    imageUrl: katherineImage,
    imageAlt: "e-commerce funnel template, shopify sales funnel, digital product sales page, digital product template, Gumroad product page template, lead magnet funnel for coaches, React product landing page, passive income website template, stripe checkout website, course sales funnel",
    link: "/moneyOnMind",
    reverse: false,
  },
  {
    title: "Mobeality",
    description:
      "Mobeaulity is the 1st Beauty Supply Airstream — an elevated & streamlined mobile shopping experience.",
    imageUrl: katieImage,
    imageAlt: "web design for women entrepreneurs, feminine website design, launch-ready website, low tech funnel, no code website template, simple website for coaches, website for mindset coach, template for spiritual entrepreneurs, web app for service-based business, women-owned business website",
    link: "/mobeaulity",
    reverse: true,
  },
];

const ProjectCard = ({ title, description, imageUrl, imageAlt, link, reverse }) => (
  
  <div
    className={`relative flex flex-col lg:flex-row ${
      reverse ? "lg:flex-row-reverse" : ""
    } items-center gap-12 my-4`}
  >
    {/* Horizontal Blue Line */}
    <div
      className={`hidden lg:block absolute top-1/2 h-px w-24 ${
        reverse
          ? "right-1/2 translate-x-[calc(100%+2rem)]"
          : "left-1/2 -translate-x-[calc(100%+2rem)]"
      }`}
      style={{ transform: "translateY(-50%)" }}
    ></div>

    {/* Image */}
    <div className="w-full lg:w-[700px]">
      <img
        src={imageUrl}
        alt={imageAlt}
        className="shadow-lg w-full h-auto object-cover"
      />
    </div>

    {/* Text */}
    <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left px-4">
      <h2 className="text-3xl lg:text-4xl  text-gray-900 mb-4">
        {title}
      </h2>
      <p className="text-gray-700 mb-4 max-w-md">{description}</p>
      <a
        href={link}
        className="text-orange-600 uppercase tracking-wider text-sm font-medium hover:underline"
      >
        View Project →
      </a>
    </div>
  </div>
);

export default function ClientWork() {

<Helmet>
  <title>Our Work | Portfolio of Websites for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Browse our portfolio of custom websites and digital platforms designed for women-owned businesses in Baltimore, Atlanta, Houston, New York City, and beyond."
  />
  <meta
    name="keywords"
    content="web design portfolio Baltimore, website design examples Augusta GA, New Orleans women entrepreneurs websites, Macon GA business website portfolio, Baton Rouge LA custom website examples, Shreveport LA web design projects, Atlanta GA women-owned business websites, Houston TX web design portfolio, Austin TX creative entrepreneur websites, Dallas TX women-led business websites, New York City website design examples, Washington DC women-owned brand websites, Philadelphia PA web design projects, Memphis TN women entrepreneur websites, past client web design showcase Baltimore, Atlanta professional website portfolio, Houston TX responsive web design examples, New York City startup website portfolio, Washington DC creative agency portfolio, Philadelphia PA women-owned business websites, Memphis TN digital design projects, Augusta GA web design showcase, Baton Rouge LA brand-focused websites, Shreveport LA women entrepreneurs portfolio, Macon GA small business websites, Dallas TX custom websites for women founders, Austin TX strategic design projects, New Orleans women-led business websites, client portfolio Woaom Web Design, women entrepreneurs city-focused web design"
  />
</Helmet>


  return (
    <section className="bg-[#F3FDFC] min-h-screen">

<div
  className="relative bg-cover bg-center object-top w-full"
  style={{
    clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
    backgroundImage: `url(${HeroBg})`,
    minHeight: "600px", // Mobile default
  }}
>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/30 z-0"> 

        <NavLite/>
   
         <div className="mx-auto w-full max-w-7xl px-5 md:px-10 md:py-20 pb-20">
          <div className="flex items-center justify-center">
            <h1 className=" text-white italic text-4xl font-bold max-w-60">
            Our Work
            </h1>
          </div>
        </div>
      </div>
    
         </div>
      <div className="py-16 px-6 lg:px-24">
        {projects.map((project, idx) => (
          <ProjectCard key={idx} {...project} />
        ))}
        
      </div>
   
      <Footer />
    </section>
  );
}
